import { getRuntimeConfig } from '@eig-builder/core-utils/helpers/runtime-config-helper'

/**
 * Gets the right Ubersmith billing url based on the partner id
 * @param {Number} partnerId The partner id of the account
 */
export const getBaseBillingUrl = partnerId => {
  const billingUrls = getRuntimeConfig()._urls.crmBillingUrls

  if (partnerId === 40 || partnerId === 50 || partnerId === 60) {
    return billingUrls.gator
  }
  return billingUrls.uber
}
